module.exports = __webpack_public_path__ + "img/quotas.40dc3647.svg";